module.exports = __webpack_public_path__ + "img/icon-fzbz.1277dc75.png";